import React, { FC } from 'react';
import { GenNavTile, UniversalLink } from '@/components';
import {
  TypeAccountNavTileFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  buildPayloadUrl,
  trackItemClickedEvent,
} from '@/utils/rudderstack';
import { getCtaTextStyles } from '@/components/utils';

export type SubscriberShopTileProps = {
  tile: TypeAccountNavTileFields;
  hasValidSubscriptions: boolean;
};

const SubscriberShopTile: FC<SubscriberShopTileProps> = ({
  tile,
  hasValidSubscriptions,
}) => {
  if (!hasValidSubscriptions) {
    return null;
  }

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: buildPayloadUrl(tile.buttonLink?.fields as TypeLink_internalFields),
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.SUBSCRIBER_SHOP_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      badge={tile.badge?.fields}
      titleDecorator={
        <UniversalLink
          link={tile.buttonLink}
          classes={`w-fit underline font-bold ${getCtaTextStyles()}`}
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(SubscriberShopTile);
